<div class="d-flex">
  <div class="ms-3 hstack gap-3">
    <app-data-box [label]="'Ingresso'" [data]="entrata | date:'yyyy-MM-dd | hh:mm:ss'"></app-data-box>
    <app-data-box [label]="'Uscita'" [data]="uscita | date:'yyyy-MM-dd | hh:mm:ss'"></app-data-box>
  </div>
</div>